/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string } from 'prop-types'
import { jsx, Label, Text } from 'theme-ui'
import { Field } from 'formik'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import './formInputs.css'
import { Circle } from '../../../icons/index'

const RadioButtonGroupItem = ({
  value,
  label,
  selectedValue,
  groupId,
  centerRadio = false,
  ...props
}) => {
  let style = {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 20,
    width: 20,
    bg: selectedValue === value ? 'forest' : 'paleSilver',
    borderRadius: 20,
    border: selectedValue !== value ? '1px solid #979491' : undefined,
  }
  if (centerRadio) {
    style = {
      ...style,
      top: '50%',
      left: '50%',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    }
  }
  return (
    <Label
      sx={{ pointerEvents: 'none' }}
      {...props}
      data-automtation-id={`radio-button-group-item-${groupId}-${value}`}
    >
      <div
        sx={{
          width: 'auto',
          position: !centerRadio && 'relative',
          pl: 30,
          cursor: 'pointer',
          userSelect: 'none',
          pointerEvents: 'auto',
        }}
      >
        <Field
          type="radio"
          name={groupId}
          value={value}
          sx={{
            position: 'absolute',
            opacity: 0,
            cursor: 'pointer',
            height: 0,
            width: 0,
          }}
        />
        <span sx={style}>
          {selectedValue === value ? (
            <Circle sx={{ bg: '#83928B', ml: '6px', mt: '6px' }} />
          ) : null}
        </span>
        <Text variant="xSmallText">{label}</Text>
      </div>
    </Label>
  )
}

RadioButtonGroupItem.propTypes = {
  value: string,
  label: string,
  groupId: string,
  selectedValue: string,
  centerRadio: bool,
}

export default RadioButtonGroupItem
